<template>
	<div :class="classes">
		<div v-if="showDeferredInviteNotification" :class="deferredInviteNotificationClasses">
			<div class="deferred-invitation-banner__notification-banner-segment">
				<FontAwesomeIcon
					:icon="[ 'fas', 'info-circle' ]"
				/>
				<div>{{ $t( "common.DeferredInvitationBanner_deferredInviteNotificationText" ) }}</div>
			</div>
			<div class="deferred-invitation-banner__notification-banner-segment deferred-invitation-banner__notification-banner-segment--right">
				<TeamingButton
					type="SECONDARY"
					size="SMALL"
					@click="onSendInviteClicked"
				>{{ $t( "common.DeferredInvitationBanner_sendInvitationText" ) }}</TeamingButton>
			</div>
		</div>
		<div v-else-if="showSuccessfulInviteNotification" :class="successfulInviteNotificationClasses">
			<div class="deferred-invitation-banner__notification-banner-segment">
				<FontAwesomeIcon
					:icon="[ 'fas', 'check-circle' ]"
				/>
				<div>
					{{ $t( "common.DeferredInvitationBanner_successfulInviteNotificationText" ) }}
				</div>
			</div>
			<div class="deferred-invitation-banner__notification-banner-segment deferred-invitation-banner__notification-banner-segment--right">
				<FontAwesomeIcon
					:icon="[ 'fas', 'times', ]"
					class="deferred-invitation-banner__notification-banner-close-icon"
					@click="onCloseSuccessfulInviteNotificationClicked"
				/>
			</div>
		</div>
		<div v-else><!-- intentionally empty --></div>
	</div>
</template>

<script>
import TeamingButton from "../buttons/TeamingButton.vue";

export default {
	name: "DeferredInvitationBanner",
	emits: [ "invite", "close", ],
	components: {
		TeamingButton,
	},
	props: {
		className: {
			type: String,
			default: "",
		},
		showDeferredInviteNotification: {
			type: Boolean,
			required: true,
		},
		showSuccessfulInviteNotification: {
			type: Boolean,
			required: true,
		},
	},
	data() {
		return {};
	},
	computed: {
		classes() {
			return {
				"deferred-invitation-banner": true,
				"deferred-invitation-banner--hidden": !( this.showDeferredInviteNotification || this.showSuccessfulInviteNotification ),
				[ this.className ]: !!this.className,
			};
		},
		deferredInviteNotificationClasses() {
			return {
				"deferred-invitation-banner__notification-banner": true,
				"deferred-invitation-banner__notification-banner--info": true,
			};
		},
		successfulInviteNotificationClasses() {
			return {
				"deferred-invitation-banner__notification-banner": true,
				"deferred-invitation-banner__notification-banner--success": true,
			};
		},
	},
	methods: {
		onSendInviteClicked() {
			this.$emit( "invite" );
		},
		onCloseSuccessfulInviteNotificationClicked() {
			this.$emit( "close" );
		},
	},
};
</script>

<style lang="scss" scoped>
.deferred-invitation-banner {
	width: 100%;
	display: flex;
	flex-direction: column;
}

.deferred-invitation-banner--hidden {
	display: none;
}

.deferred-invitation-banner__notification-banner {
	display: flex;
	flex-direction: row;
	justify-content: space-evenly;

	@include font-and-line-for(-1);

	padding: 0.375rem 0.765625rem;
	min-height: 2.75rem;
}

.deferred-invitation-banner__notification-banner--info {
	background-color: $deferred-invitation-banner-background-color--info;
	color: $deferred-invitation-banner-color--info;
}

.deferred-invitation-banner__notification-banner--success {
	background-color: $deferred-invitation-banner-background-color--success;
	color: $deferred-invitation-banner-color--success;
}

.deferred-invitation-banner__notification-banner-segment {
	height: 100%;
	width: 100%;

	display: flex;
	flex-direction: row;
	justify-content: flex-start;
	align-items: center;
	gap: 0.765625rem;
}

.deferred-invitation-banner__notification-banner-segment--right {
	flex-direction: row-reverse;
}

.deferred-invitation-banner__notification-banner-close-icon {
	cursor: pointer;
}
</style>
